import config from '../config/config';

const JSONP_RANDOM_MAX = config.jsonp.randomMax;
const JSONP_CALLBACK_PREFIX = config.jsonp.callbackPrefix;
const JSONP_TIMEOUT_MS = config.jsonp.timeoutMs;
const SCRIPT_TAG = config.common.domTags.script;

/**
 * POI検索関数（JSONP方式）
 * サーチAPIでPOI検索を行う
 * @returns {Promise<Array>} 検索結果
 */
export async function searchPoiAPI(searchTerm) {
  return new Promise((resolve) => {
    try {
      const term = String(searchTerm || '').trim();
      if (!term) {
        resolve([]);
        return;
      }

      // JSONP用のコールバック名をランダム生成（複数同時呼び出しへの衝突対策）
      const callbackName = JSONP_CALLBACK_PREFIX + Math.floor(Math.random() * JSONP_RANDOM_MAX);
      // API URL組立（json.wrf=callbackNameを付与してJSONP形式）
      const url = `${config.api.searchPoiCode(term)}&json.wrf=${callbackName}`;

      // JSONP実行用のscript要素を作成
      const script = document.createElement(SCRIPT_TAG);
      script.src = url;
      script.async = true;

      let timeoutId;

      const cleanup = () => {
        clearTimeout(timeoutId);
        delete window[callbackName];
        if (script.parentNode) {
          document.body.removeChild(script);
        }
      };

      // APIが <callbackName>(data) で返す前提
      window[callbackName] = function (data) {
        cleanup();
        try {
          const docs = data?.docs || data?.response?.docs || [];
          resolve(docs);
        } catch (error) {
          resolve([]);
        }
      };

      // タイムアウト
      timeoutId = setTimeout(() => {
        cleanup();
        resolve([]);
      }, JSONP_TIMEOUT_MS);

      // script読み込みエラー
      script.onerror = () => {
        cleanup();
        resolve([]);
      };

      document.body.appendChild(script);
    } catch (e) {
      resolve([]);
    }
  });
}